module.exports = __webpack_public_path__ + "assets/img/3e9c9079f2e816cded0f044a0c7e5678.svg";